export const VIDEO_REVIEW = 'VIDEO_REVIEW';